import axios from 'axios';

export interface EarningsCalendarItem {
    symbol: string;
    date: string; // YYYY-MM-DD
    epsActual: number | null;
    epsEstimated: number | null;
    revenueActual: number | null;
    revenueEstimated: number | null;
    lastUpdated: string;
    companyName: string;
    industry: string;
    sector: string;
    exchange: string;
    imageUrl: string;
    marketCap: number;
}

const API_URL = import.meta.env.VITE_APP_API_URL || 'http://localhost:5000';

export const EarningsService = {
    getEarningsCalendar: async (from: string, to: string): Promise<EarningsCalendarItem[]> => {
        try {
            const response = await axios.get(`${API_URL}/earnings/calendar`, {
                params: { from, to },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching earnings calendar:', error);
            throw error;
        }
    },
    getRecentEarningsTranscript: async (symbol: string): Promise<{ symbol: string; year: number; quarter: string; date: string; content: string }> => {
        try {
            const response = await axios.get(`${API_URL}/earnings/get-recent-earnings`, {
                params: { symbol },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching earnings transcript:', error);
            throw error;
        }
    },
};
